import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFormik } from 'formik';
import { styled } from '@mui/material/styles';
// @mui
import {
	TextField,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Paper,
	Grid,
	Button,
	MenuItem,
	IconButton,
	InputLabel,
	Stack,
	CircularProgress,
} from '@mui/material';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import { bannerValidationSchema } from '../../utils/validation/BannerValidation';
import { AddBanner, EditBanner } from '../../actions/BannersAction';
import { GetCategoryById, GetCategoryForDropdown } from '../../actions/CategoriesAction';
import { GetUploadedFile, UploadBannerImage } from '../../actions/UploadActions';
import { SetNewAlert } from '../../actions/AlertActions';
import { ShowUploadLoader } from '../../actions/CommonAction';
import { BannerLinkTypeArr, DisplayStatusArray } from '../common/constants';
// import { makeStyles } from '@material-ui/core/styles';
// import './common/category.css';
// ----------------------------------------------------------------------
const BootstrapDialogTitle = (props) => {
	const { children, onClose, ...other } = props;
	return (
		<DialogTitle sx={{ m: 0, p: 2 }} {...other}>
			{children}
			{onClose ? (
			<IconButton
				aria-label="close"
				onClick={onClose}
				sx={{
				position: 'absolute',
				right: 12,
				top: 8,
				}}
			>
				<CloseIcon />
			</IconButton>
			) : null}
		</DialogTitle>
	);
};

BootstrapDialogTitle.propTypes = {
	children: PropTypes.node,
	onClose: PropTypes.func.isRequired,
};

export default function BannerDiaglogBox(props) {
	
	/* START Configure Data On Page */

	const dispatch = useDispatch();
	const { data } = props;
	const [upload, setUpload] = useState([]);
	const [showProductList, setShowProductList] = useState(false);
	const [isImageUploaded, setIsImageUploaded] = useState(false);

	const {
		addBannerLog,
		editBannerLog,
		categoriesForDropdown,
		categoryById,
		bannerImage,
		uploadBannerImageLog,
		showUploadLoader,
	} = useSelector((state) => ({
		addBannerLog: state.banners.addBannerLog,
		editBannerLog: state.banners.editBannerLog,
		categoriesForDropdown: state.categories.categoriesForDropdown,
		categoryById: state.categories.categoryById,
		bannerImage: state.upload.bannerImage,
		uploadBannerImageLog: state.upload.uploadBannerImageLog,
		showUploadLoader: state.common.showUploadLoader,
	}));// END useSelector

	/* END Configure Data On Page */

	/* START Action Functions */

	const findCategoryNameById = (id) => {
		const found = categoriesForDropdown.find((e) => e.id === id);
		if (found) {
			return found.category_name;
		}
		return null;
	};

	const findProductNameById = (id) => {
		const found = categoryById?.products.find((e) => e.id === id);
		if (found) {
			return found.product_name;
		}
		return null;
	};// END findProductNameById

	const checkData = (e) => {
		if(!values.link_type){
			dispatch(
				SetNewAlert({
					msg: 'Please select banner link type first.',
					alertType: 'danger',
				})
			);
			e.preventDefault();
			return false;
		}
		if(values.link_type === BannerLinkTypeArr[2].value){
			if (!values.category) {
				dispatch(
					SetNewAlert({
						msg: 'Please select category first',
						alertType: 'danger',
					})
				);
				e.preventDefault();
				return false;
			}
			if (!values.product) {
				dispatch(
					SetNewAlert({
						msg: 'Please enter product first',
						alertType: 'danger',
					})
				);
				e.preventDefault();
				return false;
			}
		}
		return true;
	}; // END checkData

	/* END Action Functions */

	/* START Handle Change Functions */

	const handleImgChange = (e) => {
		// if (e.target.files && e.target.files[0] && checkData(e)) 
		if (e.target.files && e.target.files[0])
		{
			const ext = e.target.value.split('.').pop();
			const formData = new FormData();
			if (ext !== 'jpg' && ext !== 'png' && ext !== 'jpeg') {
				dispatch(
					SetNewAlert({
						msg: 'Only png jpeg and jpg type file allowed',
						alertType: 'danger',
					})
				);
			} else {
				formData.append('upload_for', 'BANNER_IMAGE'); 				
				formData.append('image', e.target.files[0]);
				formData.append('banner_link_type', values.link_type);
				if(values.link_type === BannerLinkTypeArr[2].value){
					formData.append('category_name', values.link_type === BannerLinkTypeArr[2].value ? findCategoryNameById(values.category): null);
					formData.append('product_name', values.link_type === BannerLinkTypeArr[2].value ? findProductNameById(values.product): null);
				}
				dispatch(ShowUploadLoader({ loading: true, type: 'bannerImage' }));
				dispatch(UploadBannerImage(formData));
				// setUpload(uploadedContent)
				if (e.target.files.length !== 0) {
				setFieldValue('image', 'something');
				} else {
				setFieldValue('image', '');
				}
			}
		}
	};// END handleImgChange

	const handleImageDelete = (data) => {
		const filteredArray = upload.filter((item) => item.file_path !== data.file_path);
		setUpload(filteredArray);
		setIsImageUploaded(false);
		setFieldValue('image', '');
	};// END handleImageDelete

	const handleCategoryChange = (e) => {
		dispatch(GetCategoryById(e.target.value));
		setShowProductList(true);
		setFieldValue('product', '');
	};// END handleCategoryChange

	const handleBannerLinkChange = (e) => {
        console.log('handleBannerLinkChange', e.target.value, BannerLinkTypeArr);
    }// END handleBannerLinkChange

	const handleProductChange = (e) => {
        setFieldValue("product",e.target.value); 
        // productKey = categoryById.products.find((event) => event.id === e.target.value).product_key;
        // setFieldValue("product_key",categoryById.products.find((event) => event.id === e.target.value).product_key);
        // errors.product_key = false;
        // touched.product_key = false;
    }// END handleProductChange

	/* END Handle Change Functions */

	/* START Use Effect */

	React.useEffect(() => {
		dispatch(GetCategoryForDropdown());
		//   dispatch(GetUploadedFile(27))
		if (data) {
			dispatch(GetCategoryById(data.banner_product?.category_id));
			setShowProductList(true);
			// const uploadedContent = upload;
			// uploadedContent.pictures = ["data:image/svg+xml;name=close-modal.svg;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyNiAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTMiIGN5PSIxMyIgcj0iMTIuNSIgc3Ryb2tlPSIjMkUyRjc0Ii8+CjxwYXRoIGQ9Ik0xMi45OTQgMTQuNTk4QzEyLjE1MjggMTUuNDUwMiAxMS4zMzcxIDE2LjI3NjcgMTAuNTIxNCAxNy4xMDMxQzEwLjAxNDQgMTcuNjE3NiA5LjUwNzMxIDE4LjEzMiA4Ljk5Njg2IDE4LjY0MjlDOC41ODgxNiAxOS4wNTI4IDcuODc0MjIgMTkuMTA3NiA3LjQwOTU2IDE4Ljc2OThDNi44OTU3MiAxOC4zOTYgNi44NTY3MSAxNy41ODMzIDcuMzQxNzIgMTcuMDc5MUM3Ljg4MjcgMTYuNTE4NCA4LjQzNTU0IDE1Ljk2OTcgOC45ODMzIDE1LjQxNTlDOS43MjA5OSAxNC42NyAxMC40NTg3IDEzLjkyNDEgMTEuMTk4MSAxMy4xNzk5QzExLjI1NTcgMTMuMTIzMyAxMS4zMjY5IDEzLjA4MDUgMTEuNDM1NSAxMi45OTk5QzExLjE5OTggMTIuNzc4NyAxMS4wMDQ3IDEyLjYwNTUgMTAuODE5OSAxMi40MjAzQzkuNjgxOTggMTEuMjc0OSA4LjU0NzQ2IDEwLjEyNjEgNy40MTI5NSA4Ljk3ODkzQzYuOTc1NDIgOC41MzgyNSA2LjkzOTgxIDcuODU3NTIgNy4zMjgxNiA3LjQwMzEzQzcuNzEzMTEgNi45NTIxNiA4LjM3NjE4IDYuODY0NzEgOC44NTEwMiA3LjIxNjIyQzguOTkxNzggNy4zMTkxMSA5LjExMDQ4IDcuNDUyODUgOS4yMzQyOCA3LjU3ODAyQzEwLjQ0IDguNzg4NiAxMS42NDI0IDEwLjAwMDkgMTIuODQ4MSAxMS4yMTE1QzEyLjg5MjIgMTEuMjU2IDEyLjkzOCAxMS4yOTcyIDEyLjk5NCAxMS4zNTA0QzEzLjAzOTcgMTEuMzA5MiAxMy4wODIxIDExLjI3NDkgMTMuMTIxMSAxMS4yMzU1QzE0LjM4OTYgOS45NTQ1OSAxNS42NTY0IDguNjcyIDE2LjkyNDkgNy4zOTExMkMxNy4yOTEyIDcuMDIwNzUgMTcuNzg4MSA2LjkyMzAxIDE4LjIzMDcgNy4xMzA0OUMxOC42NjQ4IDcuMzMyODIgMTguOTI0MyA3Ljc3NTIxIDE4Ljg4NyA4LjI2NTYyQzE4Ljg2NSA4LjU3NTk4IDE4LjcyMDggOC44MjI4OSAxOC41MDM3IDkuMDQyMzdDMTcuMjUwNSAxMC4zMDI3IDE2LjAwNDEgMTEuNTY4MSAxNC43NTI1IDEyLjgzMDFDMTQuNzA4NSAxMi44NzQ3IDE0LjY1NDIgMTIuOTA5IDE0LjU4OTcgMTIuOTU4N0MxNC45NTYgMTMuMzI3NCAxNS4yOTg2IDEzLjY3MzggMTUuNjQxMiAxNC4wMjAxQzE2LjY0MTcgMTUuMDI2NyAxNy42NDczIDE2LjAyOCAxOC42NDI4IDE3LjAzOTdDMTkuMjU4NCAxNy42NjU2IDE5LjA1MTUgMTguNjczOCAxOC4yNDc3IDE4LjkyOTNDMTcuNzY2MSAxOS4wODE5IDE3LjMxMTYgMTguOTkyNyAxNi45MzY4IDE4LjYxMDRDMTUuNjgwMiAxNy4zMzYzIDE0LjQyMDIgMTYuMDY0IDEzLjE2MTggMTQuNzkxN0MxMy4xMDkzIDE0LjczODYgMTMuMDYzNSAxNC42Nzg2IDEyLjk5NzMgMTQuNjAxNEwxMi45OTQgMTQuNTk4WiIgZmlsbD0iIzJFMkY3NCIvPgo8L3N2Zz4K"]
			// uploadedContent.pictures = data?.banner_image?.length!==0 ? [data.banner_image[0].file_path]:[]
			// setUpload(uploadedContent)
			if (data?.banner_image?.length !== 0) {
				setUpload([{ file_path: data.banner_image[0].file_path }]);
				setIsImageUploaded(true);
				setFieldValue('image', 'something');
			} else {
				setIsImageUploaded(false);
			}
		}
	}, [data]);// END React.useEffect

	const firstRun = React.useRef(true);
	React.useEffect(() => {
		if (firstRun.current) {
			firstRun.current = false;
			return;
		}
		props.onClose();
	}, [addBannerLog, editBannerLog]);// END React.useEffect

	const secondRun = React.useRef(true);
	React.useEffect(() => {
		// console.log('Banner upload use effect bannerImage:', bannerImage);
		if (secondRun.current) {
			secondRun.current = false;
			return;
		}
		setUpload([{ file_path: bannerImage.url }]);
		setIsImageUploaded(true);
		dispatch(ShowUploadLoader({ loading: false, type: '' }));
	}, [uploadBannerImageLog]);// END React.useEffect

	/* END Use Effect */

	/* START Formik */

	const formik = useFormik({
		initialValues: {
			title: data ? data.banner_title : '',
			description: data ? data.banner_description : '',
			image: '',
			sequence: data ? data.sequence : '',
			displayOnHomePage: 1,
			isActive: data ? data.is_active : 1,			
			link_type: data?(data.banner_link_type===null)?"No Link":data?.banner_link_type:"",
            web_url: data?(data.banner_web_url===null)?"":data?.banner_web_url:"",
            category: data?(data.banner_product?.category_id===null)?"":data?.banner_product?.category_id:"",
            product: data?(data.banner_product?.id===null)?"":data.banner_product?.id:"",
		},
		validationSchema: bannerValidationSchema,
		onSubmit: (value) => {
			
			if(value.link_type === BannerLinkTypeArr[1].value){
                // const urlRegex = /^(http[s]?:\/\/){0,1}(w{3,3}?\.)[-a-z0-9+&@#/%?=~_|!:,.;]*[-a-z0-9+&@#/%=~_|]/;
                const urlRegex = /((?:https?:\/\/|www\.)(?:[-a-z0-9]+\.)*[-a-z0-9]+.*)/i;
                const result =  value.web_url.match(urlRegex);              
                if(
                    value.web_url === "" || 
                    value.web_url === undefined || 
                    result === null
                ){
                    return  dispatch(SetNewAlert({
                        msg: "Please enter valid web URL",
                        alertType: "danger",
                    }));
                }
            }

            if(value.link_type === BannerLinkTypeArr[2].value){
                if(value.category === "" || value.category === undefined){
                    return  dispatch(SetNewAlert({
                        msg: "Please select a target category",
                        alertType: "danger",
                    }));
                }
            }

            if(value.link_type === BannerLinkTypeArr[2].value){
                if(value.product === "" || value.product === undefined){
                    return  dispatch(SetNewAlert({
                        msg: "Please select a target product",
                        alertType: "danger",
                    }));
                }
            }
            
			const reqObj = {
				banner_title: value.title,
				banner_description: value.description,
				banner_image: "",
				is_display_on_homepage: value.displayOnHomePage,
				is_active: value.isActive,
				sequence: value.sequence,
				banner_link_type: value.link_type,
				product_id: value.product,
                banner_web_url:  ""
                // product_key:  "",
			};

			if(value.link_type === BannerLinkTypeArr[1].value && value.web_url !== "")
                reqObj.banner_web_url =  value.web_url;
            else if(value.link_type === BannerLinkTypeArr[2].value){
                reqObj.product_id =  value.product;
                // reqObj.banner_product_key =  productKey;
            }
			
			if (isImageUploaded) {
				if (data) {
					reqObj.banner_image = upload?.[0].file_path;
					dispatch(EditBanner(reqObj, data.id));
				}
				else {
					reqObj.banner_image = bannerImage?.url;
					dispatch(AddBanner(reqObj));
				}
			}

			return true;
		},
	});// END useFormik

	const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps, setFieldValue } = formik;

	/* END Formik */

  	return (
		<>
			<Dialog
				open={props.open}
				// onClose={props.onClose}
				className="dialog-box-section"
			>
				<BootstrapDialogTitle id="customized-dialog-title" onClose={props.onClose}>
					Banner
				</BootstrapDialogTitle>
				<DialogContent dividers>
					<Grid container spacing={2}>
						<Grid item xs={12} sm={12} md={12}>
							<TextField
								id="outlined-name-input"
								label="Banner Title"
								inputProps={{ maxLength: 30 }}
								type="text"
								fullWidth
								// error={Boolean(touched.title && errors.title)}
								// helperText={touched.title && errors.title}
								{...getFieldProps('title')}
							/>
						</Grid>
						<Grid item xs={12}>
							<TextField
								multiline
								rows={2}
								id="outlined-name-input"
								label="Description"
								inputProps={{ maxLength: 100 }}
								type="text"
								fullWidth
								// error={Boolean(touched.description && errors.description)}
								// helperText={touched.description && errors.description}
								{...getFieldProps('description')}
							/>
						</Grid>
						<Grid item xs={12} sm={12} md={12}>
                            <TextField
                                id="link_type"
                                name="link_type"
                                select
                                label="Banner Link Type*"
                                fullWidth
                                error={Boolean(touched.link_type && errors.link_type)}
                                helperText={touched.link_type && errors.link_type}
                                onChange={(e)=>{
                                    handleBannerLinkChange(e)
                                    formik.handleChange(e)
                                }}
                                value={values?.link_type}
                                // {...getFieldProps('link_type')}
                            >
                                {BannerLinkTypeArr?.map((option) => (
                                    // disabled={!(option.value==="all")}
                                    <MenuItem key={option.value} value={option.value} >
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        {                            
                            values?.link_type === BannerLinkTypeArr[1].value ?
                            <Grid item xs={12} sm={12} md={12}>
                                <TextField
                                    id="outlined-name-input"
                                    label="Banner Web URL*"
                                    inputProps={{ maxLength: 250 }}
                                    type="text"
                                    value={values?.web_url}
                                    fullWidth
                                    error={Boolean(touched.web_url && errors.web_url)}
                                    helperText={touched.web_url && errors.web_url}
                                    {...getFieldProps('web_url')}
                                />
                            </Grid> : 
                            values?.link_type === BannerLinkTypeArr[2].value ?
                            <>
                                <Grid item xs={12} sm={12} md={12}>
                                    <TextField
                                        id="category"
                                        name="category"
                                        select
                                        label="Target Category*"
                                        onChange={(e)=>{
                                            handleCategoryChange(e)
                                            formik.handleChange(e)
                                        }}
                                        value={values.category}
                                        fullWidth
                                        error={Boolean(touched.category && errors.category)}
                                        helperText={touched.category && errors.category}
                                        // {...getFieldProps('category')}
                                    >
                                        {
											categoriesForDropdown?.map((option) => (
												<MenuItem key={option.id} value={option.id}>
													{option.category_name}
												</MenuItem>
                                        	))
										}
                                    </TextField>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12}>
                                    <TextField
                                        id="productId"
                                        select
                                        name="status"
                                        label="Target Product*"
                                        value={values.product}
                                        onChange={(e)=>{
                                            handleProductChange(e)
                                            formik.handleChange(e)
                                        }}
                                        fullWidth
                                        error={Boolean(touched.product && errors.product)}
                                        helperText={touched.product && errors.product}
                                        // {...getFieldProps('product')}
                                    >
                                        {
											showProductList?categoryById?.products?.map((option) => 
												<MenuItem key={option.id} value={option.id}>
													{option.product_name}
												</MenuItem>
											):null
										}
                                    </TextField>
                                </Grid> 
                                {/* <Grid item xs={12} sm={12} md={12}>
                                    <TextField
                                        hidden={true}
                                        id="product_key"
                                        label="product_key*"
                                        inputProps={{ maxLength: 70 }}
                                        type="text"
                                        value={values?.product_key}
                                        fullWidth
                                        // error={Boolean(touched.product_key && errors.product_key)}
                                        // helperText={touched.product_key && errors.product_key}
                                        // {...getFieldProps('product_key')}
                                    />
                                    </Grid> */}
                            </> : ""
                        }
						<Grid item xs={12} sm={12} md={12}>
							<TextField
								id="sequence"
								name="sequence"
								label="Sequence*"
								inputProps={{ maxLength: 5 }}
								type="number"
								onChange={(e) => {
									if (e.target.value.length === 6) {
										return;
									}
									setFieldValue('sequence', e.target.value);
									formik.handleChange(e);
								}}
								value={values.sequence}
								fullWidth
								error={Boolean(touched.sequence && errors.sequence)}
								helperText={touched.sequence && errors.sequence}
								// {...getFieldProps('sequence')}
							/>
							</Grid>
						<Grid item xs={12} sm={12} md={12}>
							<TextField
								id="ActiveStatus"
								select
								name="status"
								label="Is Active"
								fullWidth
								error={Boolean(touched.isActive && errors.isActive)}
								helperText={touched.isActive && errors.isActive}
								{...getFieldProps('isActive')}
							>
								{DisplayStatusArray.map((option) => (
								<MenuItem key={option.value} value={option.value}>
									{option.label}
								</MenuItem>
								))}
							</TextField>
						</Grid>
						<Grid item xs={12}>
							<InputLabel sx={{ mb: '10px', fontWeight: 600 }}>Banner Image</InputLabel>
							<Grid item xs={12}>
								{
									isImageUploaded ? 
									upload?.map((value, index) => 
										// eslint-disable-next-line react/jsx-key
										<Stack direction="row" alignItems="center">
											<Grid xs={8}>
												<TextField
													id="image"
													name="image"
													type="text"
													fullWidth
													InputProps={{
														readOnly: true,
													}}
													value={value?.file_path?.split('/').pop()}
													error={Boolean(touched.image && errors.image)}
													helperText={touched.image && errors.image}
													// {...getFieldProps('productMediaUrl')}
												/>
											</Grid>
											<CloseIcon
												onClick={() => handleImageDelete(upload?.[0]?.file_path)}
												style={{ marginLeft: '10px', cursor: 'pointer' }}
											/>
										</Stack>
									)
									: 
									showUploadLoader?.loading && showUploadLoader.type === 'bannerImage' ? 
										<CircularProgress style={{ color: '#FFA728' }} />
									:
									<IconButton 
										color="#393939" 
										aria-label="upload picture" 
										component="label"
										onClick={checkData}
									>
										<input hidden accept="image/*" type="file" onChange={handleImgChange} />
										<CloudUploadOutlinedIcon fontSize="large" />
									</IconButton>
								}
								<div className="errorMessage">{touched.image && errors.image}</div>
							</Grid>
						</Grid>
					</Grid>
				</DialogContent>
				<DialogActions sx={{ justifyContent: 'end', pr: '25px' }}>
					<Button
						variant="outlined"
						onClick={props.onClose}
						sx={{
							minWidth: '100px',
							color: (theme) => theme.palette.text.darkGrey,
							borderColor: (theme) => theme.palette.text.darkGrey,
						}}
					>
						Cancel
					</Button>
					<Button variant="contained" disabled={showUploadLoader.loading} onClick={formik.handleSubmit} style={{ minWidth: '100px' }}>
						Save
					</Button>
				</DialogActions>
			</Dialog>
		</>
 	);// END return
}// END BannerDiaglogBox
